/**
 * @desc 保存
 */
const URL = "/rantion-plat-data-flow";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.platDataFlow.AmzFinancialEventModel>, options?: any) {
  return updateResponse(
    http(URL + `/test/saveFinancialEvent`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
